import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

const TEXT_LINE_HEIGHT = 18;
const TEXT_MIN_LINES = 2;

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    tooltip: {
      maxWidth: 480,
    },
    description: {
      whiteSpace: 'pre-wrap',
      display: '-webkit-box',
      '-webkit-line-clamp': TEXT_MIN_LINES,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      maxHeight: TEXT_LINE_HEIGHT * TEXT_MIN_LINES,
    },
    languageChip: {
      height: 18,
      padding: theme.spacing(0.25, 0.5),
      marginLeft: theme.spacing(0.5),
      color: COLORS.gray.gray40,
      flexGrow: 1,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    labelText: {
      flexShrink: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'CustomToneOfVoiceCard' }
);
